import { useCallback as u } from "react";
import { usePrevious as f } from "@material-bank/ds-utils";
import { useDialogsStore as m } from "../../stores/dialogsControllerStore.js";
import "@tanstack/react-query";
import "zustand";
import "zustand/middleware";
import "../../stores/toastsStore.js";
import { jsxs as D, Fragment as h, jsx as l } from "theme-ui/jsx-runtime";
const y = (g) => {
  const {
    dialogComponentsConfig: i
  } = g, o = m.use.dialog(), n = f(o), t = m.use.closeDialog(), s = o && i[o.name], p = n && i[n.name], c = u((C) => {
    var a, e, r;
    o && "options" in o && o.options && "onOpenChange" in o.options && typeof ((a = o.options) == null ? void 0 : a.onOpenChange) == "function" && ((r = (e = o.options) == null ? void 0 : e.onOpenChange) == null || r.call(e, C)), t();
  }, [t, o]);
  return /* @__PURE__ */ D(h, {
    children: [n && n !== o && p && /* @__PURE__ */ l(p, {
      ..."options" in n && n.options,
      open: !1
    }, n.name), o && s && /* @__PURE__ */ l(s, {
      ..."options" in o && o.options,
      open: !0,
      onOpenChange: c
    }, o.name)]
  });
};
export {
  y as DialogsController
};
